import { render } from "./upload-custom-emoji.vue?vue&type=template&id=1fe1e63e"
import script from "./upload-custom-emoji.vue?vue&type=script&lang=js"
export * from "./upload-custom-emoji.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__